
const cssconstants = { Tooltipfs: '1rem' }

export default cssconstants